export default "__VITE_ASSET__Gk5c_Mce__"